import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { updateTcOrder } from 'actions/tc/orders';
import { MenuItem, SelectField, TextField } from 'material-ui';
import _ from 'lodash';

const tcContracts = [];

class CommissionAndContracts extends React.PureComponent {

    handleChangeCommission = value => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.commission = value;

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    changeContract = (value) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.contract = value;

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    render() {
        const { contract = null, commission = null } = this.props.tcOrder;
        const { contracts } = this.props;
        
        return (
            <div className='row'>
                <div className='col-xs-2'>
                    Commission:
                </div>
                <div className='col-xs-4'>
                    <TextField
                        name='commission'
                        style={{ fontSize: '13px' }} 
                        value={commission || ''}
                        type='number'
                        onChange={e => this.handleChangeCommission(parseFloat(e.target.value))}
                        fullWidth
                    />
                </div>
                <div className='col-xs-2'>
                    Contract:
                </div>
                <div className='col-xs-4'>
                    <SelectField 
                        onChange={(_e, _i, value) => this.changeContract(value)}
                        value={contract}
                        style={{ marginTop: '12px', fontSize: '13px' }}
                        fullWidth
                        autoWidth
                    >
                        {
                            contracts && contracts.map( (ctr, index) => {
                                return (
                                    <MenuItem
                                        key={`ctr_${index}`} 
                                        value={ctr._id} 
                                        primaryText={ctr.name} 
                                    />
                                );
                            })
                        }
                    </SelectField>
                </div>
            </div>
        );
    }
}

export default connect(
    ({contracts}) => {
        return {
            contracts: contracts.items,
        };
    },
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(CommissionAndContracts);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/CommissionAndContracts.jsx